import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import {
  slugify,
  capitalize,
} from '../../helpers';

import FiltersResetButton from './FiltersResetButton';

class FiltersFileTypes extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleChangeFilter(e) {
    const {
      checked,
      value,
    } = e.target;
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;
    let { types: newSelected } = filters;
    if (checked) {
      newSelected.push(value);
      addFilter({
        type: 'types',
        key: `${value}`,
        label: capitalize(value),
        title: intl.formatMessage({ defaultMessage: 'Type' }),
      });
    } else {
      newSelected = newSelected.filter(s => (`${s}` !== `${value}`));
      removeFilter('types', value);
    }
    handleChangeFilters({ types: newSelected });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ types: [] });
    clearSelectedFilters('types');
  }

  render() {
    const {
      intl,
      isOpen,
      availableFilters,
      filters,
      handleToggleFilter,
      prefix,
    } = this.props;
    const selected = filters.types;

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-type-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'File type' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-type-filter-form">
            {availableFilters.map(ft => (
              <FormGroup key={`filetype-${slugify(ft.key)}`}>
                <Label for={`${prefix}checkFileType-${slugify(ft.key)}`} check>
                  <Input
                    type="checkbox"
                    name="fileType"
                    id={`${prefix}checkFileType-${slugify(ft.key)}`}
                    className="input-check check-s"
                    value={ft.key}
                    checked={selected.find(s => (s === ft.key)) || false}
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    {capitalize(ft.key)}
                  </span>
                </Label>
              </FormGroup>
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filters: props.customFilters || state.Files.filters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
  clearSelectedFilters: props.customClearSelectedFilters || ((filterType) => {
    dispatch(deleteSelectedFilter(filterType, null));
  }),
});

FiltersFileTypes.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  availableFilters: PropTypes.array.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

FiltersFileTypes.defaultProps = {
  prefix: '',
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileTypes));
